import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { IndexedMap, MapUtils } from './map.utils';

export class FormUtils {
  private static getFirstInvalidControl(controls: IndexedMap<string, AbstractControl>): string | null {
    const invalid = MapUtils.keyValues(controls).find(([, control]) => control.invalid);
    if (invalid) {
      const [invalidControlKey, invalidControl] = invalid;
      if (invalidControl instanceof FormControl) {
        return invalidControlKey;
      }
      if (invalidControl instanceof FormGroup) {
        return FormUtils.getFirstInvalidControl(invalidControl.controls);
      }
    }
    return null;
  }

  static focusFirstInvalidControl(controls: IndexedMap<string, AbstractControl>) {
    const invalid = FormUtils.getFirstInvalidControl(controls);
    if (invalid) {
      const element = document.getElementById(invalid);
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      element?.focus();
    }
  }
}
